<div class="page-innder-body portlet light">
  <div class="portlet-body">
    <div class="d-flex justify-content-center align-items-center mt-3">
      <div class="container border p-4 border-light rounded" style="box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
        <form class="p-4" #form="ngForm"
          >
          <!-- Full Name -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="FirstName" class="form-label">
                <span class="text-danger">*</span> {{ 'registration.firstName' | transloco }}
              </label>
              <input type="text" id="FirstName" [(ngModel)]="signupForm.FirstName" class="form-control"
                [placeholder]="'registration.firstName' | transloco" name="FirstName" required>
              </div>
              <div class="col-md-6">
                <label for="LastName" class="form-label">
                  <span class="text-danger">*</span> {{ 'registration.lastName' | transloco }}
                </label>
                <input type="text" id="LastName" [(ngModel)]="signupForm.LastName" class="form-control"
                  [placeholder]="'registration.lastName' | transloco" name="LastName" required>
                </div>
              </div>

              <!-- Email and Phone -->
              <div class="row mb-3">
                <div class="col-md-8">
                  <label for="EmailAddress" class="form-label">
                    <span class="text-danger">*</span> {{ 'registration.emailAddress' | transloco }}
                  </label>
                  <input type="email" id="EmailAddress" [(ngModel)]="signupForm.Email" class="form-control"
                    [placeholder]="'registration.emailAddress' | transloco" name="email" required>
                  </div>
                  <div class="col-md-4">
                    <label for="PhoneNumber" class="form-label">{{ 'registration.phoneNumber' | transloco }}</label>
                    <input type="tel" id="PhoneNumber" [(ngModel)]="signupForm.PhoneNumber" class="form-control"
                      [placeholder]="'registration.phoneNumber' | transloco" name="PhoneNumber">
                    </div>
                  </div>

                  <!-- Password Fields -->
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label for="Password" class="form-label">
                        <span class="text-danger">*</span> {{ 'registration.password' | transloco }}
                      </label>
                      <input type="password" id="Password" [(ngModel)]="signupForm.Password" class="form-control"
                        [placeholder]="'registration.password' | transloco" name="Password" required>
                      </div>
                      <div class="col-md-6">
                        <label for="ConfirmPassword" class="form-label">
                          <span class="text-danger">*</span> {{ 'registration.confirmPassword' | transloco }}
                        </label>
                        <input type="password" id="ConfirmPassword" [(ngModel)]="signupForm.ConfirmPassword" class="form-control"
                          [placeholder]="'registration.confirmPassword' | transloco" name="ConfirmPassword" required>
                          @if (isPasswordMismatch()) {
                            <div class="text-danger mt-1">{{ 'registration.passwordsDoNotMatch' | transloco }}</div>
                          }
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="form-label" for="Currency Code">
                            {{ 'registration.currencyCode' | transloco }}</label>
                            <input type="text" id="CurrencyCode" [placeholder]="'registration.currencyCode' | transloco"
                              class="form-control" [(ngModel)]="currencyCode" name="CurrencyCode" disabled="true" />
                            </div>
                          </div>
                        </div>

                        <!-- Business Name (Artist) -->
                        @if (signupForm.AccountType === 'Artist') {
                          <div class="row mb-3">
                            <div class="col-md-6">
                              <label for="BusinessName" class="form-label">{{ 'registration.businessName' | transloco }}</label>
                              <input type="text" id="BusinessName" [(ngModel)]="signupForm.BusinessName" class="form-control"
                                [placeholder]="'registration.businessName' | transloco" name="BusinessName">
                              </div>
                            </div>
                          }

                          <!-- Account Type -->
                          <div class="row mb-4">
                            <div class="col-12">
                              <h4 class="dsH4">{{ 'registration.accountType' | transloco }} <span class="text-danger">*</span></h4>
                              <p class="dsText">{{ 'registration.accountTypeHelp' | transloco }}</p>
                            </div>
                            <div class="col-md-6">
                              <div class="form-check">
                                <input class="form-check-input dsRadio" type="radio" name="AccountType" id="AccountTypeArtist"
                                  value="Artist" [(ngModel)]="signupForm.AccountType">
                                  <label class="form-check-label" for="AccountTypeArtist">{{ 'registration.freeArtistAccount' | transloco }}</label>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-check">
                                  <input class="form-check-input dsRadio" type="radio" name="AccountType" id="AccountTypeGallery"
                                    value="Gallery" [(ngModel)]="signupForm.AccountType">
                                    <label class="form-check-label" for="AccountTypeGallery">{{ 'registration.freeGalleryAccount' | transloco }}</label>
                                  </div>
                                </div>
                              </div>

                              <!-- Gallery Name -->
                              @if (signupForm.AccountType === 'Gallery') {
                                <div class="row mb-3">
                                  <div class="col-md-6">
                                    <label for="GalleryName" class="form-label">
                                      <span class="text-danger">*</span> {{ 'registration.galleryName' | transloco }}
                                    </label>
                                    <input type="text" id="GalleryName" [(ngModel)]="signupForm.BusinessName" class="form-control"
                                      [placeholder]="'registration.galleryName' | transloco" name="businessName" required>
                                    </div>
                                  </div>
                                }

                                <!-- Artwork Type -->
                                @if (signupForm.AccountType === 'Artist') {
                                  <div class="row mb-3">
                                    <div class="col-md-6">
                                      <label for="artType" class="form-label">
                                        <span class="text-danger">*</span> {{ 'registration.artworkType' | transloco }}
                                      </label>
                                      <select class="form-select" name="artType" [(ngModel)]="signupForm.PrimaryArtTypeId">
                                        <option value="" disabled selected>{{ 'registration.selectArtworkType' | transloco }}</option>
                                        @for (artType of artTypes; track artType) {
                                          <option [value]="artType.Id">{{ artType.Name }}</option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                }

                                <!-- Find Artists/Galleries Checkbox -->
                                @if (signupForm.AccountType) {
                                  <div class="form-check mb-4">
                                    <input class="form-check-input" type="checkbox" [(ngModel)]="showAdditionalInfo" name="p-checkbox"
                                      id="binary">
                                      <label class="form-check-label" for="binary">{{ 'registration.findArtistsOrGalleries' | transloco }}</label>
                                    </div>
                                  }

                                  <!-- Additional Information -->
                                  @if (showAdditionalInfo) {
                                    <div>
                                      <div class="row mb-3">
                                        <div class="col-md-6">
                                          <label for="Country" class="form-label">
                                            <span class="text-danger">*</span> {{ 'registration.country' | transloco }}
                                          </label>
                                          <select id="Country" class="form-select" [(ngModel)]="selectedCountryId"
                                            (change)="onCountryChange($event)" name="Country">
                                            <option value="">{{ 'registration.selectCountry' | transloco }}</option>
                                            @for (country of countries; track country) {
                                              <option [value]="country.id">{{ country.name }}</option>
                                            }
                                          </select>
                                        </div>
                                        <div class="col-md-6">
                                          <label for="State" class="form-label">
                                            <span class="text-danger">*</span> {{ 'registration.state' | transloco }}
                                          </label>
                                          <select id="State" class="form-select" [(ngModel)]="selectedStateId" [disabled]="!selectedCountryId"
                                            (change)="onStateChange($event)" name="State">
                                            <option value="">{{ 'registration.selectState' | transloco }}</option>
                                            @for (state of states; track state) {
                                              <option [value]="state.id">{{ state.name }}</option>
                                            }
                                          </select>
                                        </div>
                                      </div>
                                      <div class="row mb-3">
                                        <div class="col-md-8">
                                          <label for="City" class="form-label">{{ 'registration.city' | transloco }}</label>
                                          <select id="City" class="form-select" [(ngModel)]="selectedCityId" [disabled]="!selectedStateId"
                                            (change)="onCityChange($event)" name="City">
                                            <option value="">{{ 'registration.selectCity' | transloco }}</option>
                                            @for (city of cities; track city) {
                                              <option [value]="city.id">{{ city.name }}</option>
                                            }
                                          </select>
                                        </div>
                                        <div class="col-md-4">
                                          <label for="Zip" class="form-label">{{ 'registration.postCode' | transloco }}</label>
                                          <input type="text" id="Zip" [(ngModel)]="signupForm.Zip" class="form-control" name="Zip"
                                            [placeholder]="'registration.zip' | transloco">
                                          </div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-12">
                                            <label for="Address1" class="form-label">{{ 'registration.address1' | transloco }}</label>
                                            <input type="text" id="Address1" [(ngModel)]="signupForm.AddressLine1" class="form-control"
                                              [placeholder]="'registration.address1Placeholder' | transloco" name="Address1">
                                            </div>
                                          </div>
                                          <div class="row mb-3">
                                            <div class="col-12">
                                              <label for="Address2" class="form-label">{{ 'registration.address2' | transloco }}</label>
                                              <input type="text" id="Address2" [(ngModel)]="signupForm.AddressLine2" class="form-control"
                                                [placeholder]="'registration.address2Placeholder' | transloco" name="Address2">
                                              </div>
                                            </div>
                                          </div>
                                        }

                                        <!-- Submit Button -->
                                        <div class="row ">

                                          <div class="col-12">
                                            <button type="button" class="btn btn-primary w-100" pButton [label]="'registration.register' | transloco"
                                              (click)="register()"
                                [disabled]="(!signupForm.FirstName || !signupForm.Email || !signupForm.Password || 
                                  (signupForm.AccountType === 'Artist' ? (!signupForm.PrimaryArtTypeId) : !signupForm.BusinessName) || 
                                  (showAdditionalInfo && (!selectedCountryId || !selectedStateId)))">
                                            </button>
                                          </div>

                                        </div>


                                      </form>
                                      <!-- Already have an account-->
                                      <div class="mt-2">{{ 'registration.alreadyHaveAccount' | transloco }} <a routerLink="/login" class="text-primary">{{ 'registration.loginNow' | transloco }}</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>